import React, { useState } from 'react'
import { ApiHttpService } from 'cms/utils/http/api'

function UserGalleryForm({userId,...props}) {

    const [url,setUrl] = useState(null)
    
    const [loading,setLoading] = useState(false)
    const [error,setError] = useState(null)
    const [done,setDone] = useState(null)

    const SaveChanges = () => {

        setError(null)
        
        if (!url) {
            setError("Please enter Url")
            return;
        }

        setLoading(true)
        ApiHttpService.saveUserGallery(userId,url).then(data => {
            if (data.id){
                setDone("Changes saved successfully");
                props.callback(data)
            }
            setLoading(false)
        })
    }
  
    const onChange = (e) => {
        //alert(e.target.name)
        switch (e.target.name) {
            case 'url':
                setUrl(e.target.value)
                break;
            default:

                break;
        }
    }


  return (
    <div>
        <div className="form-group">
            <input type="text" value={url} name="url" onChange={onChange} className="form-control post-title" placeholder="https://youtu.be" />
        </div>
        <div className="form-group mt-10">
            <button className="btn btn-primary pull-right" onClick={SaveChanges}>{loading ? "": "Save Changes"  }</button>
            <div className="clear"></div>
        </div>
        {error &&
            <div className="alert alert-danger mt-5">
                {error}
            </div>
        }
        {loading &&
            <div className="alert alert-info  mt-5">
                Please Wait...
            </div>
        }
        {done &&
            <div className="alert alert-success  mt-5">
                {done}
            </div>
        }
    </div>
  )
}

export default UserGalleryForm